import { useEffect, useSyncExternalStore } from "react";

/**
 * Feature guide: a page with tabs that are NOT in the URL (?tab=…) reports its current tab here, so the header's
 * 说明书 button opens that tab's guide (e.g. Reports → P&L / Sales tax, Payroll settings → Overtime).
 */
let current: string | null = null;
const subs = new Set<() => void>();
const emit = () => { for (const f of subs) f(); };
export function setGuideSub(v: string | null) { if (current !== v) { current = v; emit(); } }
export const getGuideSub = () => current;
export function useGuideSubValue(): string | null {
  return useSyncExternalStore((f) => { subs.add(f); return () => { subs.delete(f); }; }, () => current, () => null);
}
/** Call from a page: `useGuideSub(tab)`; cleared when the page unmounts. */
export function useGuideSub(v: string | null) {
  useEffect(() => { setGuideSub(v); return () => { if (current === v) setGuideSub(null); }; }, [v]);
}
